import React, { useState } from 'react'
import { Box, Typography, Link } from '@mui/material'
import FullLogo from './FullLogo'
import SignInMessage from './SignInMessage'
import CustomTextField from '../CustomTextField'
import CustomeButton from '../CustomeButton'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import LockIcon from '@mui/icons-material/Lock'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../../slices/authSlice'
import { fetchData } from '../../slices/userSlice'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const LoginSection = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const { status, error } = useSelector((state) => state.auth)

  const formik = useFormik({
    initialValues: {
      userName: '',
      password: '',
    },
    validationSchema: Yup.object({
      userName: Yup.string().required('BID-ID is required'),
      password: Yup.string().required('Password is required'),
    }),
    onSubmit: (values) => {
      setLoading(true)
      dispatch(login(values)).then((action) => {
        if (
          action.type === 'auth/login/fulfilled' &&
          action.payload.isSuccess
        ) {
          dispatch(fetchData())
          navigate('/admin')
        } else {
          setLoading(false)
        }
      })
    },
  })

  return (
    <Box
      sx={{
        flex: 1,
        padding: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      {/* Full Logo  */}
      <Box sx={{ marginBottom: 4 }}>
        <FullLogo />
      </Box>

      {/* Heading message  */}
      <Typography variant='h5' sx={{ fontWeight: 'bold', marginBottom: 2 }}>
        Welcome to <span style={{ color: '#F6764E' }}>Boodhana</span>
      </Typography>

      <SignInMessage
        text='Please sign-in to your account and start the adventure'
        color='black'
      />

      {/* form-Box */}
      <Box
        component='form'
        onSubmit={formik.handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: 400,
        }}>
        <CustomTextField
          icon={MailOutlineIcon}
          placeholder='BID-ID'
          type='text'
          name='userName'
          value={formik.values.userName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.userName && Boolean(formik.errors.userName)}
          helperText={formik.touched.userName && formik.errors.userName}
          sx={{ width: '100%' }}
        />

        <CustomTextField
          icon={LockIcon}
          placeholder='Password'
          type='password'
          name='password'
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          sx={{ width: '100%' }}
        />
        {status === 'failed' && <p style={{ color: 'red' }}>{error}</p>}

        <CustomeButton
          type='submit'
          text='Login'
          width='55%'
          loading={loading}
        />
      </Box>

      {/* Forgot Password Link */}
      <Link
        onClick={() => navigate('/forgot')}
        underline='always'
        sx={{
          fontFamily: 'Work Sans',
          fontWeight: 500,
          textAlign: 'center',
          color: 'black',
          fontSize: '0.95rem',
          textDecorationColor: 'black',
          cursor: 'pointer',
        }}>
        Forgot password?
      </Link>
    </Box>
  )
}

export default LoginSection
